import { render, staticRenderFns } from "./PopupHandler.vue?vue&type=template&id=1bfa4764&scoped=true&"
import script from "./PopupHandler.vue?vue&type=script&lang=js&"
export * from "./PopupHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfa4764",
  null
  
)

export default component.exports